<div class="dialogTitle" mat-dialog-title>Borrar Edicion</div>
<div class="dialogContent">
  <p>Esta seguro de que desea eliminar esta edición?</p>
</div>
<div mat-dialog-actions fxLayout="row">
  <button fxFlex="40" mat-button (click)="deleteEdition()">ACEPTAR</button>
  <button fxFlex="40" mat-button (click)="close()" cdkFocusInitial>CANCELAR</button>
</div>
